import { BaseService } from "./common/base";
import type { Teleexpertise } from "../../../../api/src/teleexpertise/entities/teleexpertise.entity";
import type { FindTeleexpertiseDTO } from "../../../../api/src/teleexpertise/dto/find-teleexpertise.dto";
import type { CreateTeleexpertiseDto } from "../../../../api/src/teleexpertise/dto/create-teleexpertise.dto";
import type { UpdateTeleexpertiseDto } from "../../../../api/src/teleexpertise/dto/update-teleexpertise.dto";

export class TeleexpertiseService extends BaseService<
  Teleexpertise,
  FindTeleexpertiseDTO,
  {
    data: CreateTeleexpertiseDto;
    files: File[];
  },
  UpdateTeleexpertiseDto
> {
  constructor() {
    super("teleexpertise");
  }

  create({
    data,
    files,
  }: {
    data: CreateTeleexpertiseDto;
    files: File[];
  }): Promise<Teleexpertise> {
    const formData = new FormData();

    if (files) {
      for (const file of files) {
        formData.append("files", file);
      }
    }

    formData.append("data", JSON.stringify(data));

    return this.api
      .post(`/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res.data);
  }

  createComment(id, data) {
    return this._post(`${id}/comment`, data);
  }

  transferToOmnidoc(id, data: { topic: string }) {
    return this._post(`${id}/transfer-to-omnidoc`, data);
  }
}
